module.exports = __webpack_public_path__ + "static/media/happy-flatfy.bd1f0f40.svg";